/**
 * Center the timeline pill at `index` inside its own horizontal scroll
 * container. The pill row uses `overflow-x: auto`, so `scrollTo` works
 * reliably even with smooth behavior.
 */
export const scrollTimelineToPhase = ({
  index,
  timelineRef,
}: {
  index: number;
  timelineRef: React.RefObject<HTMLDivElement>;
}) => {
  const timelineContainer = timelineRef.current;
  if (!timelineContainer) return;

  const timelinePhase = timelineContainer.children[index] as
    | HTMLElement
    | undefined;
  if (!timelinePhase) return;

  const timelineRect = timelineContainer.getBoundingClientRect();
  const timelinePhaseRect = timelinePhase.getBoundingClientRect();
  const timelineCenter = timelinePhaseRect.left + timelinePhaseRect.width / 2;
  const timelineContainerCenter = timelineRect.left + timelineRect.width / 2;
  const timelineOffset =
    timelineContainer.scrollLeft + (timelineCenter - timelineContainerCenter);

  timelineContainer.scrollTo({
    left: timelineOffset,
    top: 0,
    behavior: "smooth",
  });
};

export default scrollTimelineToPhase;
